import React from 'react';
import { Modal, Checkbox, Typography, Divider } from 'antd';
import { TermsAndConditions, privacyPolicy } from '../helpers/TermsConditionData.js';

const scrollContainerStyle = {
  maxHeight: '300px',
  overflowY: 'auto',
  padding: '20px',
  border: '1px solid #f0f0f0',
  borderRadius: 6,
  backgroundColor: '#ffffff',
  boxShadow: 'inset 0 0 5px rgba(0,0,0,0.05)',
  marginBottom: 24,
};

const sectionTitleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  marginBottom: 12,
  color: '#2c3e50',
};

const checkboxStyle = {
  display: 'block',
  marginTop: 8,
  fontSize: '14px',
};

const TermsConditions = ({
  visible,
  acceptedTerms,
  acceptedPrivacy,
  onTermsChange,
  onPrivacyChange,
  onAcceptAll,
}) => {
const { Title, Paragraph } = Typography;

  const handleTermsChange = (e) => {
    const checked = e.target.checked;
    onTermsChange(checked);
    if (!checked) {
      onPrivacyChange(false); // reset privacy if terms unchecked
    }
  };

  const handlePrivacyChange = (e) => {
    const checked = e.target.checked;
    onPrivacyChange(checked);
    if (checked && acceptedTerms) {
      onAcceptAll(); // close modal when both accepted
    }
  };

  return (
    <Modal
      title={<Title level={3} style={{ margin: 0 }}>Geneinsure :- Terms of use and Privacy Policy</Title>}
      visible={visible}
      footer={null}
      closable={false}
      width={820}
      style={{ top: 50 }}
    >
      {/* Terms Section */}
      <div>
        <div style={sectionTitleStyle}>Terms of Use</div>
        <div style={scrollContainerStyle}>
          <Paragraph style={{ whiteSpace: 'pre-wrap' }}>
            {TermsAndConditions}
          </Paragraph>
        </div>
        <Checkbox style={checkboxStyle} checked={acceptedTerms} onChange={handleTermsChange}>
          I have read and agree to the <strong>Terms of Use</strong>
        </Checkbox>
      </div>

      {/* Privacy Section */}
      {acceptedTerms && (
        <>
          <Divider />
          <div>
            <div style={sectionTitleStyle}>Privacy Policy</div>
            <div style={scrollContainerStyle}>
              <Paragraph style={{ whiteSpace: 'pre-wrap' }}>
                {privacyPolicy}
              </Paragraph>
              <p>{privacyPolicy}</p>
            </div>
            <Checkbox style={checkboxStyle} checked={acceptedPrivacy} onChange={handlePrivacyChange}>
              I have read and accept the <strong>Privacy Policy</strong>
            </Checkbox>
          </div>
        </>
      )}
    </Modal>
  );
};

export default TermsConditions;
